import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 11.586V7a.75.75 0 0 1 1.5 0v4.586c0 .066.026.13.073.177l2.707 2.707a.75.75 0 1 1-1.06 1.06l-2.707-2.707a1.75 1.75 0 0 1-.513-1.237"
  }));
}
var IcClock = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClock));

export { IcClock as I };
